import { z } from '@/utils/zod'

export const TestPresenterSchema = z.object({
    type: z.literal('test'),
})

export type TestPresenter = z.infer<typeof TestPresenterSchema>
